import React, { useState } from "react";
import pic1 from "../../images/pic1.png";
import Footer from "../../common/Footer/Footer"
import ForgotForm from "./ForgotForm";

const style = {
  background: `url(${pic1}), lightgray 50%`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  height: "100.9vh",
  marginTop: -50,
  padding: 10,
};
function ForgotPage() {
  

  return (
    <>
    <div style={style} >
      <ForgotForm />
      
    </div>
    <Footer />
    </>
  );
}

export default ForgotPage;
